import React from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CAT_YELLOW } from './utils/styles';

// ─── Data ─────────────────────────────────────────────────────────────────────
const FAQ_ITEMS = [
  {
    q: 'How do I request API access?',
    a: 'Submit a request through the embedded PowerApps form in Step 4 of the onboarding flow. Make sure your business case, API endpoints, and consumer details are ready before submitting.',
  },
  {
    q: 'What details are required to start onboarding?',
    a: 'You will need: a valid Client ID (AC, CC, or Pseudo), a defined business case covering the APIs you need, consumer type (UI/Backend/Service), and the intended data usage. All these are covered step-by-step in the onboarding guide above.',
  },
  {
    q: 'How long does onboarding take?',
    a: 'Client ID generation typically takes 5 business days. Entitlements setup and APIGEE configuration may take an additional 2–5 business days depending on complexity. Validation can begin immediately after access is granted.',
  },
  {
    q: 'Who should I contact if I face issues?',
    a: 'Each step in the onboarding guide lists a dedicated POC. For general issues, reach out to the Cosmos team at Service_Adoption_Team_Cosmos@cat.com or use the "Contact Us" button in the main section.',
  },
  {
    q: 'Can I request access to multiple APIs at once?',
    a: 'Yes. Include all required API endpoints in your form submission for one single product. The team will map them to selected APIGEE product and configure entitlements accordingly.',
  },
  {
    q: 'What is the difference between QA and PROD environments?',
    a: 'QA is limited to internal/dev testing with restricted traffic. PROD access requires a finalized business case tied to an application with real usage. Both environments are configured separately.',
  },
];

interface FAQSectionProps {
  classes: any;
  expanded: string | false;
  onChange: (panel: string | false) => void;
}

const FAQSection = React.forwardRef<HTMLDivElement, FAQSectionProps>(
  ({ classes, expanded, onChange }, ref) => {
    return (
      <div ref={ref}>
          <div className={classes.section}>
            <Typography className={classes.sectionLabel}>FAQ</Typography>
            <Typography className={classes.sectionTitle}>Common Questions</Typography>
            <Typography className={classes.sectionSubtitle}>
            Quick answers before you dive into the onboarding steps.
          </Typography>

          <div className={classes.faqContainer}>
            {FAQ_ITEMS.map((item, idx) => (
              <Accordion
                key={idx}
                className={classes.faqAccordion}
                expanded={expanded === `faq-${idx}`}
                onChange={(_: React.ChangeEvent<{}>, isExpanded: boolean) =>
                  onChange(isExpanded ? `faq-${idx}` : false)
                }
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: CAT_YELLOW }} />}>
                  <Typography className={classes.faqSummary}>{item.q}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.faqDetails}>{item.a}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>

          <Divider style={{ marginTop: 56 }} />
        </div>
      </div>
    );
  }
);

export default FAQSection;